<script>
  import GroupSettings from '@app-components/group/GroupSettings.svelte';
  import GroupActionsBar from '@app-components/group/GroupActionsBar.svelte';
  import { createEventDispatcher, onMount } from 'svelte';

  import Text from '@components/Text.svelte';
  import Header from '@components/Header.svelte';

  import Notification from '@utils/notification';
  import Track from '@utils/track';
  import BrowserUtils from '@utils/browser-utils';
  import ComponentEvents from '@utils/component-events';

  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recsStore = getGroupStore('recsStore');
  let sectionsStore = getGroupStore('sectionsStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  import { getCurrentUserStore } from '@stores/current_user';
  import GroupAjax from '@ajax/group';

  import ListAuthors from '@app-components/ListAuthors.svelte';
  import AddRecExternalModal from '@app-components/modal/AddRecExternalModal.svelte';
  import DemoAccountNotification from '@app-components/DemoAccountNotification.svelte';
  import FixedAddButton from '@app-components/group/FixedAddButton.svelte';
  import Quiz from '@app-components/group/Quiz.svelte';
  import DesktopGridView from '@app-components/group/DesktopGridView.svelte';
  import DesktopMapView from '@app-components/group/DesktopMapView.svelte';
  import Toggle from '@components/Toggle.svelte';
  import AdminInfo from '../profile/components/AdminInfo.svelte';
  import { inview } from 'svelte-inview';

  export let loadedRecObjects = true;
  export let loadedRecs = true;
  export let selectedGroupView = 'grid';

  export let loadSections;
  import { browser } from '$app/environment';
  let currentUser = getCurrentUserStore('default');

  let group = groupStore;
  let recs = recsStore;
  let recObjects = recObjectsStore;
  let sections = sectionsStore;
  // const minimumRecCount = 5;

  let marginRight = 0;

  const dispatch = createEventDispatcher();

  const dispatchUpdateGroupView = (newView) => {
    dispatch('update-group-view', { newView });
  };

  let sticky = false;
  let stickyHeader = false;
  let scrollDirection = 'down';

  const updateSticky = (e) => {
    if (e && e.detail) {
      sticky = !!e.detail.sticky;
      scrollDirection = e.detail.scrollDirection;
    }
  };

  import jQuery from 'jquery';

  $: loaded = true;

  let quizInstance;

  $: brokenLinksCount = group.broken_weblinks_count
    ? loadedRecObjects
      ? recObjects.filter((u) => u.weblink_broken).length
      : 0
    : 0;

  let showAddModal = false;

  let quizQuestion;
  let quizExpanded = true;
  let withQuiz = false;

  const scrollToFirstBrokenLinkItem = function () {
    const elem = document.getElementsByClassName('broken-link-rec-object')[0];
    if (elem) {
      elem.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const setRightPosition = function () {
    if (brokenLinksCount > 0) {
      let elem = document.getElementsByClassName('group-header')[0];
      let elem2 = document.getElementsByClassName('toast-desktop')[0];
      if (elem && elem2) {
        let headerWidth = elem.getBoundingClientRect().width;
        let toastWidth = elem2.getBoundingClientRect().width;
        let margin = headerWidth - toastWidth;
        if (margin > 0) {
          marginRight = margin;
        }
        return true;
      } else {
        return false;
      }
    }
  };

  const initialPositionAdjust = function () {
    let completed = false;
    const intervalId = setInterval(handleRightPosition, 50);
    function handleRightPosition() {
      completed = setRightPosition();
      if (completed) {
        clearInterval(intervalId);
      }
    }
  };

  let updateGroup = async function (data) {
    try {
      let resp = await GroupAjax.update(group, data);
      groupStore.set({ ...group, ...resp });
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
          type: 'error',
        });
        group = group;
      }
    }
  };

  let endOfPageReached = function () {
    Track.groupPageEndReached({ currentUser: currentUser, group: group });
  };

  let addedRec = async function (e) {
    let resp = e.detail;
    let elem = jQuery(`[data-rec-object-id="${resp.rec_object_id}"]`)[0];
    if (quizQuestion) {
      quizInstance.saveAnswer(quizQuestion.id, true);
      quizQuestion = null;
    }
    await BrowserUtils.goToElement(elem, {
      block: 'center',
    });

    ComponentEvents.trigger('refresh-broken-owl');
  };

  let setupGroupNameWidthAndShow = function (node) {
    let recalculate = function () {
      node = jQuery(node);
      let currentHeight = node.height();
      node.css('width', 'unset');

      if (currentHeight > 50) {
        let span = node.find('span');
        let display = span.css('display');
        span.css('display', 'inline-block');
        let newWidth = span.width();
        span.css('display', display);
        node.css('width', newWidth + 20);
      }
    };

    recalculate();
    setTimeout(recalculate, 250);

    return {
      update() {
        recalculate();
      },
    };
  };

  onMount(() => {
    initialPositionAdjust();
    jQuery(window).resize(function () {
      setRightPosition();
    });
    let unsubGroup = groupStore.subscribe((x) => (group = x));
    let unsubRecs = recsStore.subscribe((x) => (recs = x));
    let unsubRecObjects = recObjectsStore.subscribe((x) => (recObjects = x));
    let unsubSections = sectionsStore.subscribe((x) => (sections = x));
    let unsubUser = currentUser.subscribe((x) => (currentUser = x));
    return () => {
      unsubGroup();
      unsubUser();
      unsubRecs();
      unsubRecObjects();
      unsubSections();
    };
  });
</script>

<style style="text/scss" lang="scss" global>
  /* NOTE: this component uses global styles so that child components can access them too,
     but it is scoped using classes ("group-page-container-desktop") so the styles don't
     leak across the app. */
  .grid-container-select-none {
    user-select: none;
  }

  .group-header-sticky {
    position: fixed;
    z-index: 6 !important;
    width: 100%;
    background: white;
    left: 0px;
    top: 0px;
    height: 66px;
    padding: 0px;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.04);
    border-bottom: 1px solid var(--neutral-input-gray, #ececec);
    &.with-sections {
      box-shadow: none;
      border-bottom: 0px;
    }
    .group-header-sticky-content {
      height: inherit;
      max-width: 1180px;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .group-details-container {
        flex: 1;

        .group-name-and-settings {
          display: flex;
          align-items: center;

          .group-name {
            color: var(--neutral-dark, #1a1a1a);
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
            word-break: break-word;
            margin-right: 24px;
          }

          .group-settings {
            display: flex;
            flex-shrink: 0;
          }
        }
      }
    }
  }

  .grid-container.group-page-container-desktop {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .grid-content {
      width: 100%;
      max-width: 1180px;
      margin-left: auto;
      margin-right: auto;

      .group-header {
        margin-bottom: 36px;
        display: flex;
        align-items: flex-start;

        .group-details-container {
          flex: 1;

          .group-name-and-settings {
            display: flex;
            align-items: flex-start;

            .group-name {
              font-weight: 500;
              font-size: 30px;
              color: #1a1a1a;
              word-break: break-word;
              margin-right: 24px;
              margin-top: -8px;
            }

            .group-settings {
              display: flex;
              flex-shrink: 0;
            }
          }

          .group-description {
            margin-top: 20px;
          }

          .group-authors {
            margin-top: 22px;
          }
        }
      }
      .toast-desktop {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 8px;
        background: #fff4f5;
        border: 1px solid #ff5567;
        padding: 18px 16px;
        border-radius: 12px;
        margin-top: 32px;
        margin-bottom: 32px;
        .icon-alert {
          width: 16px;
          margin-top: 2px;
        }
        .title {
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: #ff5567;
        }
        .description {
          font-size: 12px;
          line-height: 16px;
          color: #7f7f7f;
          margin-top: 4px;
        }
      }
    }
  }

  .map-toggle {
    display: flex;
    justify-content: flex-end;
    margin-bottom: -42px;
    align-items: center;

    .map-toggle__text {
      font-size: 14px;
      font-weight: 500;
      margin-right: 18px;
    }
  }

  .quiz-expanded {
    margin-left: 300px !important;
  }

  * :global(.demo-notification) {
    max-width: 1180px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    margin-top: -50px;
    margin-bottom: -10px;
    justify-content: flex-start;
  }

  * :global(.demo-text) {
    margin-right: auto;
  }

  :global(.group-name-desktop-h1) {
    font-size: 30px;
    font-weight: 500;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    line-height: 1.3;
    overflow: hidden;
  }
</style>

<AddRecExternalModal
  quizQuestion={quizQuestion}
  bind:showModal={showAddModal}
  on:added={addedRec}
  on:close={() => {
    setTimeout(function () {
      quizQuestion = null;
    }, 100);
  }} />

<Header currentUser={currentUser} currentPage="group" quizExpanded={withQuiz && quizExpanded} />

{#if stickyHeader}
  <div class="group-header-sticky" class:with-sections={sticky && scrollDirection == 'up'}>
    <div class="group-header-sticky-content">
      <div class="group-details-container">
        <div class="group-name-and-settings">
          <span class="group-name" use:setupGroupNameWidthAndShow={group.name}>
            <Text
              on:blur={(e) => {
                updateGroup({ name: e.detail.text });
              }}
              style="width: -webkit-fill-available;"
              expand={true}
              lines={1}
              text={group.name}
              editable={group.permissions.edit} />
          </span>

          <GroupSettings group={group} recs={recs} topNavBar={true} />
        </div>
      </div>
      <GroupActionsBar
        groupStore={groupStore}
        group={group}
        loaded={loaded}
        recs={recs}
        mobile={false}
        showFloatingLikeOrComment={true} />
    </div>
  </div>
{/if}

<div class="grid-page" class:quiz-expanded={withQuiz && quizExpanded}>
  {#if group.users && group.users[0] && currentUser && currentUser.user_flag}
    <AdminInfo user_id={group.users[0].id} group_id={group.id} />
  {/if}
  <div
    style="padding: 45px 90px;"
    class="grid-container group-page-container-desktop"
    class:sticky={sticky && selectedGroupView === 'grid'}
    class:grid-container-select-none={group.permissions.edit && selectedGroupView === 'grid'}>
    <div><DemoAccountNotification buttonText="Sign up for free" /></div>

    <div class="grid-content">
      <div class="group-header">
        <div class="group-details-container">
          <div class="group-name-and-settings">
            <span class="group-name" use:setupGroupNameWidthAndShow={group.name}>
              {#if group.permissions.edit}
                <Text
                  on:blur={(e) => {
                    updateGroup({ name: e.detail.text });
                  }}
                  style="width: -webkit-fill-available;"
                  expand={true}
                  lines={10}
                  initialTextLength={1000}
                  text={group.name}
                  editable={true} />
              {:else}
                <h1 class="group-name-desktop-h1">
                  <Text
                    style="width: -webkit-fill-available;"
                    expand={true}
                    lines={10}
                    initialTextLength={1000}
                    text={group.name}
                    editable={false} />
                </h1>
              {/if}
            </span>

            <GroupSettings group={group} recs={recs} />
          </div>
          <div
            use:inview={{}}
            on:inview_change={(event) => {
              stickyHeader = !event.detail.inView;
            }}
            class="group-authors">
            <ListAuthors group={group} authors={group.users} />
          </div>
          {#if brokenLinksCount > 0}
            <div
              class="toast-desktop"
              style="margin-right: -{marginRight}px;"
              on:click|preventDefault|stopPropagation={() => {
                scrollToFirstBrokenLinkItem();
              }}>
              <img class="icon-alert" src="/images/alert.svg" alt="" />
              <div class="content">
                <div class="title">
                  {#if brokenLinksCount > 1}
                    {brokenLinksCount} items on this list have broken links!
                  {:else}
                    1 item on this list has a broken link!
                  {/if}
                </div>
                <div class="description">
                  You should consider fixing or removing these recommendations from your list, and we’ll hide all broken
                  links from any viewers.
                </div>
              </div>
            </div>
          {/if}
          {#if group.description || group.permissions.edit}
            <div class="group-description">
              <Text
                editor={true}
                linkClicked={(url) => {
                  Track.groupDescriptionLinkClicked({
                    user: currentUser,
                    group,
                    url,
                  });
                }}
                on:file-upload-complete={(e) => {
                  updateGroup({
                    description: e.detail.text,
                  });
                }}
                on:blur={(e) => {
                  updateGroup({
                    description: e.detail.text,
                  });
                }}
                lines={3}
                expand={true}
                text={group.description}
                style="color: rgba(0, 0, 0, 0.5); padding:
              0px; margin: 0px; line-height: 24px; font-size: 15px;
              margin-left: -5px; padding-left: 5px;"
                placeholder="Add a description (e.g. what's on this list, what's it useful for, who is it meant to help?)"
                editable={group.permissions.edit} />
            </div>
          {/if}
        </div>
        <GroupActionsBar groupStore={groupStore} group={group} loaded={loaded} recs={recs} mobile={false} />
      </div>
    </div>

    {#if group.map_view_enabled && loaded}
      <div class="map-toggle grid-content">
        <span class="map-toggle__text">Map</span>
        <Toggle
          enabled={selectedGroupView === 'map'}
          on:toggled={dispatchUpdateGroupView(selectedGroupView === 'map' ? 'grid' : 'map')} />
      </div>
    {/if}

    {#if selectedGroupView === 'grid'}
      <DesktopGridView
        sections={sections}
        group={group}
        currentUser={currentUser}
        recs={recs}
        recObjects={recObjects}
        on:sticky-changed={updateSticky} />
    {:else}
      <DesktopMapView sections={sections} group={group} loadedRecs={loadedRecs} currentUser={currentUser} recs={recs} />
    {/if}

    {#if loaded && (group.permissions.edit || group.permissions.contribute) && selectedGroupView !== 'map'}
      <FixedAddButton
        group={group}
        sticky={sticky}
        on:clicked={() => (showAddModal = true)}
        withQuiz={withQuiz && quizExpanded} />
    {/if}
  </div>
</div>
{#if group.permissions.edit && browser}
  <Quiz
    bind:this={quizInstance}
    bind:expanded={quizExpanded}
    bind:withQuiz={withQuiz}
    mobile={false}
    group={group}
    loadSections={() => loadSections()}
    on:clicked={(e) => {
      quizQuestion = e.detail.question;
      showAddModal = true;
    }} />
{/if}
{#if loadedRecObjects}
  <div use:inview={{}} on:enter={endOfPageReached} />
{/if}
